import { Navigate, Route, Routes } from "react-router-dom";
import { useMe } from "./api/hooks";
import { AppShell } from "./components/AppShell";
import LoginPage from "./pages/Login";
import MailboxesPage from "./pages/Mailboxes";
import AliasesPage from "./pages/Aliases";
import DomainsPage from "./pages/Domains";
import AuditPage from "./pages/Audit";
import DkimPage from "./pages/Dkim";
import DnsPage from "./pages/Dns";
import SievePage from "./pages/Sieve";
import QueuePage from "./pages/Queue";
import DocsPage from "./pages/Docs";
import DashboardPage from "./pages/Dashboard";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const me = useMe();
  if (me.isLoading) return <div className="p-8 text-muted-foreground">Loading…</div>;
  if (me.isError || !me.data) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/*"
        element={
          <RequireAuth>
            <AppShell>
              <Routes>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/mailboxes" element={<MailboxesPage />} />
                <Route path="/aliases" element={<AliasesPage />} />
                <Route path="/domains" element={<DomainsPage />} />
                <Route path="/dns" element={<DnsPage />} />
                <Route path="/dkim" element={<DkimPage />} />
                <Route path="/sieve" element={<SievePage />} />
                <Route path="/queue" element={<QueuePage />} />
                <Route path="/audit" element={<AuditPage />} />
                <Route path="/docs" element={<DocsPage />} />
              </Routes>
            </AppShell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
